import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-confirmation-message',
  templateUrl: './modal-confirmation-message.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class ModalConfirmationMessageComponent {
  @Input() callbackCancelFunction?: Function;
  @Input() callbackConfirmFunction: Function;
  @Input() title: string;
  @Input() body: string;
  @Input() buttonConfirmText : string;
  @Input() buttonCancelText : String;

  constructor(public bsModalRef : BsModalRef) { }

  onConfirm() : void {
    this.callbackConfirmFunction();
    this.bsModalRef.hide();
  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    // escape key already hides the modal
  }

  onCancel() : void{
    this.bsModalRef.hide();
  }


  onNo() {
    this.callbackCancelFunction ? this.callbackCancelFunction() : false;
    this.bsModalRef.hide();
  }

}
